import LogoImgFooter from '../../assets/logo-kasa-white.webp'

function Footer() {
    return (
      <footer>
            <img src={LogoImgFooter} alt="Logo Kasa"/> 
            <div>© 2020 Kasa. All rights reserved</div>
      </footer>
    )
  }
  
  export default Footer